import { DimensionProvider } from "@/contexts/Dimension"
import TMAProvider from "@/contexts/TMA"
import { ToastProvider } from "@/contexts/Toast"
import { UserProvider } from "@/contexts/User"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "./routes"
import * as Sentry from "@sentry/react"

import "./styles/globals.css"
import "./styles/animations.css"

import "@/i18n/i18n"
import { BrowserRouter } from "react-router"
import Error from "./error"
import { PostHogProvider } from "posthog-js/react"
import posthog from "posthog-js"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.browserApiErrorsIntegration(),
    Sentry.captureConsoleIntegration(),
  ],
  tracesSampleRate: 0.1,
  sampleRate: 0.5,
  tracePropagationTargets: [/^https:\/\/(?!.*(posthog)).*\.funfiesta\.games/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  profilesSampleRate: 0.1,
})

const FallbackError = ({
  error,
  resetError,
}: {
  error: unknown
  resetError: () => void
}) => {
  return <Error error={error as Error} resetError={resetError} />
}

posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  person_profiles: "identified_only",
  persistence: "localStorage",
})

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={FallbackError} showDialog>
    <StrictMode>
      <PostHogProvider client={posthog}>
        <BrowserRouter>
          <TMAProvider>
            <UserProvider>
              <DimensionProvider>
                <ToastProvider>
                  <div className="container flex max-w-full flex-col">
                    <RouterProvider />
                  </div>
                </ToastProvider>
              </DimensionProvider>
            </UserProvider>
          </TMAProvider>
        </BrowserRouter>
      </PostHogProvider>
    </StrictMode>
  </Sentry.ErrorBoundary>
)
